import { Link } from "@homeinstead/ui/components/Link";
import { useLocale } from "~www/components/LocaleProvider";

export const PrivacyPolicyDisclaimer = () => {
  const locale = useLocale();
  const siteUrl = locale.metadata.canonicalOrigin;

  return (
    <p className="mt-4 text-center text-new-beginnings-base text-xs">
      By clicking &ldquo;Submit,&rdquo; you agree to our{" "}
      <Link
        className="text-xs"
        href={`${siteUrl}/legal/privacy-policy`}
        size="inline"
        variant="plain"
      >
        Privacy Policy
      </Link>
      .
    </p>
  );
};
